export default {
	state: {
		dataBaseReserva: {}
	},
	getters: {
		"dataBaseReserva": state => state.dataBaseReserva
	},
	mutations: {
		setDataBaseReserva(state, payload) {
			state.dataBaseReserva = payload
		}
	},
	actions: {
		atualizarEstadoDataBaseReserva({ commit }, payload) {
			commit('setDataBaseReserva', payload)
		}
	}
};